<script>

import Vue from 'vue';
const moment = require('moment');
const nprogress = require('nprogress');
const config = require('@/config.js')[ process.env.NODE_ENV || 'development' ]

export default {
    data () {
        return {
            loading : true,
            error   : false,
        }
    },
    mounted () {
        this.$nextTick(function () {
            nprogress.done(true);
        })
    },
    watch: {
        executed( newval, oldval ) {
            if ( newval === true && oldval === false ) {
                this.loading = false;
            }
        },
    },
    computed: {
        executed() { return this.$store.state.receipt.executed; },
        item() {
            if ( this.$store.state.receipt.items === null ) { return {} }
            if ( this.$store.state.receipt.items.length !== 1 ) { this.error = true; return {}; }
            return this.$store.state.receipt.items[0];
        }, 
        backend_url() { return config.backend_url; },
        created() {
            return this.item === null ? '' : moment( this.item.created ).format( 'DD/MM/YYYY - HH:mm' );
        }
    },
    created () {
        this.loading = true;
        if ( !this.$route.query.code ) { this.error = true; this.loading = false; }
        else {
            setTimeout( () => {
                this.$store.dispatch('receipt/get_all', { options: { code: this.$route.query.code, include: true }, force_reload: true } );
            }, 1000);
        }
    },
    methods: {
        download() {
            var link  = document.createElement("a");
            link.target = '_blank';
            link.id   = 'dynamic_link';
            link.href = this.backend_url + this.item.config.final_document.url;
            var element = document.getElementById('orion')
            element.appendChild( link );
            //Add the link somewhere, an appendChild statement will do.
            //Then run this
            document.getElementById('dynamic_link').click();
        },
    },
    components: {
    }
};

</script>

<template>
 
    <b-container class="text-center" fluid>
        <b-img :src="backend_url + 'static/icons/cspfea_logo.png'" fluid alt="Responsive image" style="margin-bottom: 15px"></b-img>
        <b-card style="max-width: 600px; height: 550px; background-color: #094074; color: white; margin: auto;">
            <div v-if="loading" class="text-center" style="padding-top: 160px">
                <b-spinner style="width: 9rem; height: 9rem;" type="grow" label="Loading..."></b-spinner>
            </div>
            <div v-if="!loading && error === true" class="text-center">
            <div style="color: red; font-weight: 700; margin-top: 100px"><h3>INVALID URL</h3></div>
            </div>
            <div v-if="!loading && error === false" class="text-center">
                <b-col>
                    <h3 style="margin-bottom: 50px">{{ item.title }}</h3>
                    <b-card style="background-color: #3C6997;">
                        <table style="width: 100%;">
                            <tr>
                                <td class="text-left">
                                    <b>Title</b>
                                </td>
                                <td class="text-left">
                                    {{ item.title }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    <b>Created</b>
                                </td>
                                <td class="text-left">
                                    {{ created }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    <b>Owner</b>
                                </td>
                                <td class="text-left">
                                    {{ item.first_name }} {{ item.last_name }}
                                </td>
                            </tr>
                        </table>
                    </b-card>
                    <div style="margin-top: 100px">
                        <b-button @click="download" variant="info">download document</b-button>
                    </div>
                </b-col>
            </div>
        </b-card>
        <div style="margin-top: 20px" id="orion">This report was generated by <a href="https://www.cspfea.net/" target="_blank">CSPFEA</a> and blockchain certified</div>
    </b-container>

</template>

<style>

    body: {
        background-color: #cfd8dc;
    }

</style>

